export default __webpack_public_path__ + "static/media/notify-app-icon.54fc521e.png";